module.exports = __webpack_public_path__ + "img/n12.c80b41eb.png";